import React, {useState} from "react";
import {
    DataGrid,
    GridColDef,
    GridToolbarContainer,
    GridToolbarExport,
    GridToolbarQuickFilter
} from "@mui/x-data-grid";
import {Link, useLoaderData} from "react-router-dom";
import {CancelRounded, CheckBoxRounded, DirectionsCar, FlashOn} from "@mui/icons-material";
import {isExpress, Reg} from "./Registration";
import {Typography} from "@mui/material";


const checkerBoxer = (params: any) => {
    if (params.value) {
        return <CheckBoxRounded htmlColor={"green"}/>
    } else {
        return <CancelRounded htmlColor={"red"}/>
    }

}

const parkingColumn: GridColDef = {
    field: 'parking', headerName: 'Park', align: "center", headerAlign: "center",
    valueGetter: (params) => {
        if (params.row.payment === null) {
            return false
        } else {
            return params.row.payment.parking
        }
    },
    renderCell: checkerBoxer,
    renderHeader: () => (<DirectionsCar/>),
    width: 70,
    hideSortIcons: true
}

function buildColumns(paidParking: boolean): GridColDef[] {
    const cols: GridColDef[] = [
        {
            field: 'name', headerName: 'Player', headerAlign: "center", renderCell: (params) => (
                <Link to={'./' + params.row.playerId}>{params.value}</Link>
            )
        },
        {
            field: 'character', headerName: 'Character', renderCell: (params) => {
                return (params.row.type == "NPC") ? <Typography fontWeight={700}>NPC</Typography> : params.row.character
            }
        },
        {
            field: 'express', headerName: 'Exp', align: "center", headerAlign: "center",
            valueGetter: (params) => {
                if (params.row.player.waivers === null) {
                    return false
                } else {
                    return isExpress(params.row)
                }
            },
            renderCell: checkerBoxer,
            renderHeader: () => (<FlashOn/>),
            width: 70,
            hideSortIcons: true
        },
    ]
    if (paidParking) cols.push(parkingColumn)
    cols.push({field: 'checkedIn', headerName: 'Checked In', align: "center", headerAlign: "center", renderCell: checkerBoxer})
    return cols
}

export function QuickFilterToolBar() {
    return (
        <GridToolbarContainer>
            <GridToolbarQuickFilter/>
            <GridToolbarExport />
        </GridToolbarContainer>
    )
}


export default function CheckIn() {
    const {registrations, paidParking} = useLoaderData() as {registrations: Reg[], paidParking: boolean};

    return <React.Fragment>
        <h2>PC Registration</h2>
        <DataGrid slots={{toolbar: QuickFilterToolBar}}
                  autoHeight={true}
                  disableColumnMenu={true}
                  rows={registrations}
                  columns={buildColumns(paidParking)}
                  getRowId={(row) => row.playerId}
                  disableRowSelectionOnClick
                  density={"compact"}
        />
    </React.Fragment>
}